<style scoped>
  .contract-uid{
    display: inline-block;
  }
</style>
<template>
  <div class="contract-uid">
    <div>{{ contract.uid }}</div>
    <div class="d-flex flex-column align-center">
      <v-chip
        v-if="contract.del"
        class="mb-1"
        x-small
        color="error"
        label
      >
        已废弃
      </v-chip>

      <v-chip
        v-if="contract.is_closed"
        class="mb-1"
        x-small
        color="success"
        label
      >
        已完结
      </v-chip>

      <v-chip
        v-if="no_payment"
        class="mb-1"
        x-small
        color="grey"
        label
        outlined
      >
        无付款记录
      </v-chip>
      
    </div>

    <div
      v-if="in_fin_group"
      class="color-warning"
    >
      [付款时分析组审核]
      <i-switch
        v-model="contract.need_at_payment_audit"
        size="small"
        :loading="loading"
        @on-change="updateNeedAtPaymentAudit"
      />
    </div>
    <div v-if="nodeStatus&&nodeStatus.length">
      <Tag 
        v-for="(item,index) in nodeStatus"
        :key="index"
        :color="item.color"
        type="border"
        :fade="false"
      >
        {{ item.text }}
      </Tag>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      contract: {
        type: Object
      },
      nodeStatus: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        loading: false
      }
    },
    computed: {
      no_payment() {
        return !this.contract.has_payment;
      },
      in_fin_group() {
        const groups = this.$store.state.cur_customer.groups;
        return groups.includes('GROUP_FIN');
      }
    },
    methods: {
      updateNeedAtPaymentAudit() {
        this.loading = true;
        this.$util.ajax.post(this.$util.api.contract_update_need_at_payment_audit, {
          id: this.contract.id,
          need_at_payment_audit: this.contract.need_at_payment_audit
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const contract = res.data.contract;
            this.contract.need_at_payment_audit = contract.need_at_payment_audit;
            this.$Message.success('设置成功')
          } else {
            this.$Modal.error({title: '提示', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '提示', content: e.message});
        }).finally(() => {
          this.loading = false;
        });
      },
    }
  }
</script>
